import { GenericResource, IHttpAgent, IListResponse } from '@sparelabs/http-client-utils'
import {
  IJourneyGetResponse,
  IJourneyPatchBody,
  IJourneyPostBody,
  IListActiveJourneyResponse,
  IListJourneyQueryParams,
  IListJourneyResponse,
  Resources,
} from '../types'

/**
 * TODO: create a new lib/multimodal-client for multimodal-service, and move this there.
 */
export class JourneyResource extends GenericResource<
  IJourneyGetResponse,
  IListJourneyQueryParams,
  IJourneyPatchBody,
  IJourneyPostBody
> {
  public post = this.buildPost()
  public get = this.buildGet()

  // get and list return different types. this is a copy of the buildList function but returns a the correct type
  public list = async (
    params: IListJourneyQueryParams,
    fetchAllPages: boolean = false,
  ): Promise<IListResponse<IListJourneyResponse>> => {
    if (params.ids && params.ids.length === 0) {
      return {
        limit: params.limit ?? 50,
        skip: params.skip ?? 0,
        total: 0,
        data: [],
      }
    }

    if (fetchAllPages) {
      const data = await this.allPageFetcher.fetch<IListJourneyResponse, IListJourneyQueryParams>(this.resource, params)
      return { data, skip: 0, total: data.length, limit: data.length }
    }

    const { data } = await this.agent.get<IListResponse<IListJourneyResponse>>(this.resource, { params })
    return data
  }

  public patch = this.buildPatch()

  public async listActiveJourneys(params: IListJourneyQueryParams): Promise<IListActiveJourneyResponse> {
    const { data } = await this.agent.get<IListActiveJourneyResponse>(`${Resources.Journeys}/active`, { params })
    return data
  }

  constructor(agent: IHttpAgent) {
    super(Resources.Journeys, agent)
  }
}
